import { execFile } from 'node:child_process'
import { promisify } from 'node:util'

const execFileAsync = promisify(execFile)

/**
 * Installs Python 3.10 via the provided uv binary path.
 * This operation is idempotent — uv skips installation if Python 3.10 is already present.
 *
 * @param uvPath Absolute path to the uv binary
 */
export async function ensurePython(uvPath: string): Promise<void> {
  await execFileAsync(uvPath, ['python', 'install', '3.10'], {
    timeout: 120_000,
  })
}
